import(/* webpackMode: "eager" */ "/app/public/assets/images/portfolio/Thumbnail-1.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/portfolio/Thumbnail-10.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/portfolio/Thumbnail-11.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/portfolio/Thumbnail-12.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/portfolio/Thumbnail-13.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/portfolio/Thumbnail-14.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/portfolio/Thumbnail-15.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/portfolio/Thumbnail-2.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/portfolio/Thumbnail-4.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/portfolio/Thumbnail-5.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/portfolio/Thumbnail-6.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/portfolio/Thumbnail-7.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/portfolio/Thumbnail-8.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/portfolio/Thumbnail-9.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/portfolio/Thumbnail.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ProjectsDetails.js");
